import type { MsgDeskParams } from '@/msgdeskRuntime'

export type LegacyMsgRequestAction = 'get_msg' | 'get_msg_model'
export const INITIAL_PHP_MODEL_PREFIX = '__MSGDESK_INITIAL_PHP_MODEL__:'

export interface LegacyMsgRequestParamsOptions {
  action: LegacyMsgRequestAction
  isTestMode?: boolean
  now?: Date
  timeOffset?: number
  includeNextJs?: boolean
}

export function buildLegacyMsgRequestParams(
  params: MsgDeskParams,
  options: LegacyMsgRequestParamsOptions,
): URLSearchParams {
  const now = options.now || new Date()
  const qs = new URLSearchParams({
    action: options.action,
    show_pin: params.show_pin ?? '0',
    time_offset: String(options.timeOffset ?? now.getTimezoneOffset() * 60 * -1),
    local_time: String(now.getTime()),
    android: '0',
    is_link_view: String(params.is_link_view ?? false),
  })

  // PHP historically treated parameter presence as true, including the string
  // "false". Omit the parameter unless test mode is explicitly enabled.
  if (options.isTestMode) qs.set('is_test_mode', '1')
  if (options.includeNextJs) qs.set('nextjs', '1')
  qs.set(params.keyname || 'codekey', params.codekey)

  return qs
}
